import {
  PreliminaryPrice,
  preliminaryPriceSchema,
  price,
  PriceChange,
  priceChangeSchema,
  PriceHistory,
  Resolution,
} from '@toggle/toggle';

import { apiFetch, wretchRequest } from '~/utils/api-fetch/apiFetch';

export const getPreliminaryPrice = (
  subscribableTicker: string,
  signal?: AbortSignal
) => {
  return apiFetch<PreliminaryPrice>(
    price.preliminaryPrice.path(subscribableTicker),
    {
      schema: preliminaryPriceSchema,
      options: { signal },
    }
  );
};

export type GetPricesProps = {
  ticker?: string;
  entityTag: string;
  resolution: Resolution;
  dateFrom?: string;
  dateTo?: string;
};

export const getPrices = async ({
  ticker,
  entityTag,
  resolution,
  dateFrom,
  dateTo,
}: GetPricesProps) => {
  const params = [
    ['ticker', ticker],
    ['from', dateFrom],
    ['to', dateTo],
    ['entity_tag', entityTag],
    ['resolution', resolution],
  ].filter(i => i[1]) as [string, string][];
  const priceUrl = `${price.prices.path}?${new URLSearchParams(
    params
  ).toString()}`;

  return apiFetch<PriceHistory>(priceUrl);
};

export interface GetPriceChangeProps {
  ticker: string;
  reference: string;
  from: string;
  to: string;
}

export const getPriceChange = async ({
  ticker,
  from,
  to,
  reference,
}: GetPriceChangeProps) => {
  const params = [
    ['ticker', ticker],
    ['from', from],
    ['to', to],
    ['reference', reference],
  ].filter(i => i[1]) as [string, string][];

  const priceUrl = `${price.priceChange.path}?${new URLSearchParams(
    params
  ).toString()}`;

  return wretchRequest<PriceChange>(priceUrl, {
    schema: priceChangeSchema,
    method: 'get',
  });
};
